"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FormConsumer = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _throttleDebounce = require("throttle-debounce");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _classnames = _interopRequireDefault(require("classnames"));

var _helpers = require("./helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/jsx-no-bind */

/* eslint-disable react/no-did-update-set-state */
const FieldsContext = _react.default.createContext({});

const SetValueContext = _react.default.createContext(() => {});

const FormConsumer = ({
  children
}) => _react.default.createElement(FieldsContext.Consumer, null, fieldsData => _react.default.createElement(SetValueContext.Consumer, null, setValue => children({
  fieldsData,
  setValue
})));

exports.FormConsumer = FormConsumer;
FormConsumer.propTypes = {
  children: _propTypes.default.func.isRequired
};
/**
 * This form component's Creates new context with defined fields that are
 * avaliable for all field items inside.
 */

class Form extends _react.default.Component {
  constructor(props) {
    super(props);
    const requiredFields = props.allRequired ? props.fields : props.required;
    this.onChangeThrottled = (0, _throttleDebounce.debounce)(500, props.onChange);
    this.state = {
      fieldsData: (0, _helpers.initiateFormFields)(props.fields, requiredFields)
    };
  }

  setValue(name, value, required, options) {
    const _this$props = this.props,
          fields = _this$props.fields,
          allRequired = _this$props.allRequired,
          onChange = _this$props.onChange,
          runOnChangeInitially = _this$props.runOnChangeInitially,
          theme = _this$props.theme;

    if (!name) {
      // If no field name is provided, reset whole form
      const requiredFields = allRequired ? fields : required;
      this.setState({
        fieldsData: (0, _helpers.initiateFormFields)(fields, requiredFields)
      });
    } else {
      this.setState(prevState => {
        const fieldsData = _objectSpread(_objectSpread({}, prevState.fieldsData), (0, _helpers.processField)(name, value, required, options, theme.textLabels, theme.customValidationFunction));

        if (onChange) {
          // If onChange prop is present, run it on every form change,
          // except the initial load. When runOnChangeInitially prop is present,
          // run it also on Initial load.
          const formIsInitiated = Object.entries(prevState.fieldsData).every(item => typeof item[1].value === 'undefined');

          if (!formIsInitiated || runOnChangeInitially) {
            this.onChangeThrottled((0, _helpers.getValues)(fieldsData), name);
          }
        }

        return {
          fieldsData
        };
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.required && this.props.required && prevProps.required.toString() !== this.props.required.toString() && !this.props.allRequired) {
      this.setState({
        fieldsData: (0, _helpers.updateFieldsRequirements)(this.state.fieldsData, this.props.required)
      });
    }
  }

  render() {
    const _this$props2 = this.props,
          className = _this$props2.className,
          classes = _this$props2.classes,
          component = _this$props2.component,
          runOnChangeInitially = _this$props2.runOnChangeInitially; // Prevent puting <form> tag into a <form> tag when using form in mutlivalue inputs.

    const Component = runOnChangeInitially ? 'div' : component;
    return _react.default.createElement(Component, {
      className: (0, _classnames.default)(classes.form, {
        [className]: className
      })
    }, _react.default.createElement(FieldsContext.Provider, {
      value: this.state.fieldsData
    }, _react.default.createElement(SetValueContext.Provider, {
      value: this.setValue.bind(this)
    }, this.props.children)));
  }

}

Form.propTypes = {
  fields: _propTypes.default.array.isRequired,
  required: _propTypes.default.array,
  allRequired: _propTypes.default.bool,
  component: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  onChange: _propTypes.default.func,
  runOnChangeInitially: _propTypes.default.bool
};
Form.defaultProps = {
  component: 'form'
};

var _default = (0, _reactJss.default)(theme => ({
  form: {
    margin: 0
  }
}), {
  injectTheme: true
})(Form);

exports.default = _default;